import v3ApiClient from "./client";

const BASE = "/v3/schedule/airline-ingest";

export function ingestErrorMessage(error, fallback = "航司班期接入失败") {
    const detail = error?.response?.data?.detail;
    if (detail && typeof detail === "object" && !Array.isArray(detail) && detail.message) {
        return detail.message;
    }
    if (Array.isArray(detail)) {
        return detail.map((item) => item?.msg || item).filter(Boolean).join("；") || fallback;
    }
    if (typeof detail === "string" && detail.trim()) {
        return detail;
    }
    return error?.message || fallback;
}

export const airlineScheduleIngestApi = {
    startTask: (payload) => v3ApiClient.post(`${BASE}/tasks`, payload),
    listWorkspaceTasks: () => v3ApiClient.get(`${BASE}/tasks`),
    getTask: (taskId) => v3ApiClient.get(`${BASE}/tasks/${taskId}`),
    getFileUrl: (taskId) => v3ApiClient.get(`${BASE}/tasks/${taskId}/file-url`),
    getBySchedule: (scheduleId) => v3ApiClient.get(`${BASE}/by-schedule/${scheduleId}`),
    retryTask: (taskId) => v3ApiClient.post(`${BASE}/tasks/${taskId}/retry`),
    discardTask: (taskId) => v3ApiClient.post(`${BASE}/tasks/${taskId}/discard`),
    confirmTask: (taskId, payload) => v3ApiClient.post(`${BASE}/tasks/${taskId}/confirm`, payload),
};
